import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <section className="mt-10 text-center">
      <div className="card max-w-md mx-auto">
        <div className="text-5xl mb-3">🤔</div>
        <h1 className="text-2xl font-display font-bold mb-2">Nothing here.</h1>
        <p className="text-navy-700 mb-4">
          But you can still make someone&rsquo;s day.
        </p>
        <Link to="/" className="btn-primary no-underline">
          Send a kudos
        </Link>
      </div>
    </section>
  );
}
